import { DATAAPI } from '../../../constants/global';
import { aggregationType } from '../../types';
import type { IResponse } from '../api-utils';
import * as utils from '../utils';

const baseUrl = DATAAPI;

export interface IAggregation {
	electionsid: number[];
	constituencyid: number[];
	localGovernmentsid: number[];
	poolingUnitsid: number[];
	wardsid: number[];
	geoZonesid: number[];
	statesid: number[];
	zonesid: number[];
	resultType: string[];
}

export const pollingunit_aggregation = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-pu-results`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.pollingunit_aggregation,
		onSuccess,
		onFailure,
	});

export const pollingunit_aggregationsummaries = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-pu-results-summaries`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.pollingunit_aggregationsummaries,
		onSuccess,
		onFailure,
	});

export const pollingunit_aggregationstats = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-pus-result-overview-stats`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.pollingunit_aggregationstats,
		onSuccess,
		onFailure,
	});

export const pollingunit_aggregationvisualization = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-pus-results-visualisation`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.pollingunit_aggregationvisualization,
		onSuccess,
		onFailure,
	});

// ward

export const ward_aggregation = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-ward-results`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.ward_aggregation,
		onSuccess,
		onFailure,
	});

export const ward_aggregationsummaries = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-ward-results-summaries`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.ward_aggregationsummaries,
		onSuccess,
		onFailure,
	});

export const ward_aggregationstats = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-wards-result-overview-stats`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.ward_aggregationstats,
		onSuccess,
		onFailure,
	});

export const ward_aggregationvisualization = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-wards-results-visualisation`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.ward_aggregationvisualization,
		onSuccess,
		onFailure,
	});

// lga

export const lga_aggregation = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-lga-results`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.lga_aggregation,
		onSuccess,
		onFailure,
	});

export const lga_aggregationsummaries = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-lga-results-summaries`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.lga_aggregationsummaries,
		onSuccess,
		onFailure,
	});

export const lga_aggregationstats = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-lgas-result-overview-stats`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.lga_aggregationstats,
		onSuccess,
		onFailure,
	});

export const lga_aggregationvisualization = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-lgas-results-visualisation`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.lga_aggregationvisualization,
		onSuccess,
		onFailure,
	});

// state

export const state_aggregation = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-states-results`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.state_aggregation,
		onSuccess,
		onFailure,
	});

export const state_aggregationsummaries = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-state-results-summaries`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.state_aggregationsummaries,
		onSuccess,
		onFailure,
	});

export const state_aggregationstats = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-states-result-overview-stats`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.state_aggregationstats,
		onSuccess,
		onFailure,
	});

export const state_aggregationvisualization = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IAggregation;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: `${baseUrl}/fetch-aggregated-states-results-visualisation`,
			header: utils.header(),
			data,
		},
		actionType: aggregationType.state_aggregationvisualization,
		onSuccess,
		onFailure,
	});
